import {BrowserRouter, Navigate, Route, Routes} from 'react-router-dom';
import Login from './components/auth/Login';
import Page404 from './components/Page404';
import Layout from './components/layout/Layout';
import 'antd/dist/antd.min.css';
import {useAppSelector} from './common/hooks';

function App() {
  const state = useAppSelector((state) => state.auth);

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path='/login'
          element={state.user.token === null ? <Login /> : <Navigate to={'/'} />}
        />
        <Route
          index
          path='/*'
          element={state.user.token === null ? <Navigate to={'/login'} /> : <Layout />}
        />
        <Route path='404' element={<Page404 />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
